import { render, staticRenderFns } from "./NodeConfig.vue?vue&type=template&id=52774335&scoped=true"
import script from "./NodeConfig.vue?vue&type=script&lang=js"
export * from "./NodeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52774335",
  null
  
)

export default component.exports